import { graphql } from "@opensea/graphql"
import { ItemAvatarFragment } from "../avatar/ItemAvatar"
import { useSetItemQuickViewFragment } from "../item-page/ItemViewModal/use-set-item-quick-view.fragment"
import { itemIdentifierFragment, itemUrlFragment } from "../utils"

export const CollectionItemSearchItemFragment = graphql(
  `
    fragment CollectionItemSearchItem on Item {
      name
      tokenId
      ...itemUrl
      ...ItemAvatar
      ...itemIdentifier
      ...useSetItemQuickView
    }
  `,
  [
    ItemAvatarFragment,
    itemIdentifierFragment,
    itemUrlFragment,
    useSetItemQuickViewFragment,
  ],
)
